import { InvokeCallback } from 'xstate';
import * as Sentry from '@sentry/browser';

import { jax } from '~/api/core/legacy';
import { getServerUrl } from '~/api/core/utils';

export const rgBarService = (): InvokeCallback => (cb, onReceive) => {
  let rg = null;

  document.onreadystatechange = () => {
    if (document.readyState === 'complete') {
      rg = window?.rgBar?.({
        appName: ' Ads Manager',
        appColor: '#355d84',
        appIconClass: 'ads-manager',
        appNameLink: '/',
        currentSiteDomainName: '',
        siteSelected(site) {
          jax(
            'set_site_uuid',
            { site_uuid: site.uuid },
            () => {
              window.location = window.location.origin;
            },
            (r) => {
              alert(`could not select site: ${site.domain}`);
              Sentry.captureException(r);
            },
          );
        },
        logout() {
          // NOTE: rgRequest will try to convert the returned data from
          // 'logout' into json (see extractData). However, the data returned
          // by 'logout' is actually plaintext. This means that we get an error
          // whenever the user tries to logout, due to 'Invalid json
          // formatting'. We will eventually modify rgRequest so that it does
          // not automatically try to extract the data, but until then we don't
          // have that functionality
          fetch(getServerUrl('logout'), {
            method: 'POST',
          })
            .then(() => {
              window.location = window.location.origin;
            })
            .catch(err => {
              alert(
                'we had trouble logging you out of the facebook tool; please try again',
              );
              Sentry.captureException(err);
            });
        },
      });

      cb({ type: 'RG_BAR.ready' });
    }
  };

  onReceive((msg) => {
    if (msg.type === 'RG_BAR.updateSiteUUID') {
      rg?.update_site({ uuid: msg.uuid });
    }
  });
};
